var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5104 1.78072C12.9988 -0.326972 10.0012 -0.326973 9.48955 1.78072C9.15901 3.14227 7.5991 3.7884 6.40262 3.05937C4.55044 1.93082 2.43086 4.05039 3.55942 5.90257C4.28845 7.09906 3.64231 8.65896 2.28077 8.9895C0.173073 9.50118 0.173074 12.4987 2.28077 13.0104C3.64231 13.3409 4.28845 14.9008 3.55942 16.0973C2.43087 17.9495 4.55044 20.0691 6.40262 18.9405C7.5991 18.2115 9.15901 18.8576 9.48955 20.2192C10.0012 22.3269 12.9988 22.3269 13.5104 20.2192C13.841 18.8576 15.4009 18.2115 16.5974 18.9405C18.4496 20.0691 20.5691 17.9495 19.4406 16.0973C18.7115 14.9008 19.3577 13.3409 20.7192 13.0104C22.8269 12.4987 22.8269 9.50118 20.7192 8.9895C19.3577 8.65896 18.7115 7.09906 19.4406 5.90257C20.5691 4.05039 18.4496 1.93082 16.5974 3.05937C15.4009 3.7884 13.841 3.14227 13.5104 1.78072ZM11.5 15.05C13.7367 15.05 15.55 13.2367 15.55 11C15.55 8.7632 13.7367 6.94995 11.5 6.94995C9.26324 6.94995 7.45 8.7632 7.45 11C7.45 13.2367 9.26324 15.05 11.5 15.05Z",
    fill: "#00B061"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/Setting.a0088da25b83361489be1b311e94ea9b.svg";
export { ForwardRef as ReactComponent };